import React, { useEffect, useState, createElement } from 'react';
import Head from 'next/head';
import { v4 as uuidv4 } from 'uuid';
import { useRouter } from 'next/router';
import { useScript } from 'hooks/useScript';
import { components } from './components';
import Text from 'components/corporatiu/Text';
import __isEmpty from 'lodash/isEmpty';
import __isArray from 'lodash/isArray';
import clsx from 'clsx';
import styles from './contingutEstatic.module.scss';

const getStyleSheets = (css) => {
    if (__isEmpty(css)) {
        return null;
    }
    return __isArray(css) ? (
        css.map((href, index) => <link key={`contingut-estatic-css-${uuidv4()}`} rel='stylesheet' href={href} />)
    ) : (
        <link rel='stylesheet' href={css} />
    );
};

const getJavascripts = (js) => {
    if (__isEmpty(js)) {
        return null;
    }
    return __isArray(js) ? (
        js.map((src, index) => <script key={`contingut-estatic-javascript-${uuidv4()}`} src={src} defer></script>)
    ) : (
        <script src={js} defer></script>
    );
};

const ContingutParsejat = (props) => {
    const { contingut } = props;

    const getContent = (content) => {
        return content.map((item, index) => {
            const tipus = item.tipus.toUpperCase();
            if (tipus === 'DIVBLOCK' && !__isEmpty(item.children)) {
                const stylesDiv = clsx({
                    [styles.divBloc]: true,
                    [styles[item.props.estil]]: !!item.props.estil,
                    [item.props.class]: !!item.props.class
                });
                return (
                    <div key={`contingut-estatic-divBlock-${uuidv4()}`} className={stylesDiv}>
                        {getContent(item.children)}
                    </div>
                );
            } else {
                return (
                    <React.Fragment key={`contingut-estatic-component-${item.tipus}-${index}`}>
                        {createElement(components[tipus], {
                            ...item.props
                        })}
                    </React.Fragment>
                );
            }
        });
    };

    return <>{getContent(contingut)}</>;
};

const Contingut = (props) => {
    const { contingut } = props;
    const router = useRouter();
    const [renderContingut, setRenderContingut] = useState(<></>);
    const { isJavaScriptClientEnabled } = useScript();

    useEffect(() => {
        if (contingut && !__isArray(contingut)) {
            setRenderContingut(<Text className={styles.cos} text={contingut} />);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath, contingut]);

    return isJavaScriptClientEnabled ? <div>{renderContingut}</div> : <div dangerouslySetInnerHTML={{ __html: contingut }}></div>;
};

const ContingutEstatic = (props) => {
    const { contingut, assets, estils } = props;
    const { css, js } = assets || {};
    const arrayEstils = estils?.split(' ') || [];
    const stylesContingut = clsx({
        [styles.contentContingutEstatic]: true,
        ['estatica-corporatiu']: true,
        ...arrayEstils.reduce((acc, currentStyle) => {
            acc[styles[currentStyle]] = !__isEmpty(currentStyle);
            return acc;
        }, {})
    });

    return (
        <>
            <Head>
                {getStyleSheets(css)}
                {getJavascripts(js)}
            </Head>
            <div className={stylesContingut}>
                {__isArray(contingut) ? <ContingutParsejat contingut={contingut} /> : <Contingut contingut={contingut} />}
            </div>
        </>
    );
};

export default ContingutEstatic;
